import type { RouteRecordRaw } from 'vue-router'

const infositeRoutes: RouteRecordRaw[] = [
  {
    path: '/infosite',
    name: 'Infosite',
    component: () => import('./InfositeHome.vue')
  }
]

export default infositeRoutes
